import { isEqual } from 'lodash';

class SaveConfirmationHelper {
  private static instance: SaveConfirmationHelper;

  private methods: Record<string, (...args: any[]) => boolean | Promise<any>> = {};

  static getInstance() {
    if (!SaveConfirmationHelper.instance) {
      SaveConfirmationHelper.instance = new SaveConfirmationHelper();
    }
    return SaveConfirmationHelper.instance;
  }

  registerMethod(name: string, method: (...args: any[]) => boolean | Promise<any>) {
    this.methods[name] = method;
  }

  callMethod(name: string, ...args: any[]): boolean | Promise<any> {
    if (this.methods[name]) {
      if (name === 'saveData') {
        if (this.methods[name]?.length > 0) {
          return this.methods[name](...args, false, true);
        }
        // Always append skipReload=true for saveData
        return this.methods[name](...args, true);
      }
      return this.methods[name](...args);
    }
    console.warn(`Method '${name}' not registered.`);
    return true;
  }

  getMethod(name: string): ((...args: any[]) => boolean | Promise<any>) | undefined {
    return this.methods[name];
  }

  clearAllMethods() {
    this.methods = {};
    console.log('All registered methods have been cleared.');
  }
}

export function isDataEqual(data1: any, data2: any) {
  return isEqual(data1, data2);
}
export default SaveConfirmationHelper.getInstance();
